import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Routes from './routes'
import { store } from './store/store'

import { library } from '@fortawesome/fontawesome-svg-core'
// import {  } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons'
// import {  } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)

library.add(faFacebookF, faTwitter)

Vue.config.productionTip = false

import './assets/css/customfonts.css';
import './assets/css/style.css';






// Router
Vue.use(VueRouter);
const router = new VueRouter({
  routes: Routes,
  mode: 'history'
});

new Vue({
  store:store,
  render: h => h(App),
  router: router
}).$mount('#app')
